export default "__VITE_ASSET__BExN8YmX__"